/**
 * FundIQ product split:
 * - Document Validation = Internal workflows (+ shared / non-prefixed)
 * - ETVL Engine = External workflows (+ shared / non-prefixed)
 *
 * Names starting with "Internal" only on Document Validation.
 * Names starting with "External" only on ETVL.
 * Everything else (Combined, AP Invoice, Unidentified, etc.) on both.
 */

export const WORKFLOW_PRODUCT_SCOPE = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
};

export const matchesWorkflowProductScope = (workflowName, scope) => {
  if (!scope) return true;
  const name = String(workflowName || '').trim().toLowerCase();
  if (!name) return false;

  const isInternalNamed = name.startsWith('internal');
  const isExternalNamed = name.startsWith('external');

  if (scope === WORKFLOW_PRODUCT_SCOPE.INTERNAL) {
    return !isExternalNamed;
  }
  if (scope === WORKFLOW_PRODUCT_SCOPE.EXTERNAL) {
    return !isInternalNamed;
  }
  return true;
};

export const filterWorkflowsByProductScope = (workflows, scope) => {
  if (!scope || !Array.isArray(workflows)) return workflows || [];
  return workflows.filter((row) =>
    matchesWorkflowProductScope(row?.documentType || row?.workflowName || row?.name, scope)
  );
};

export const workflowProductTitle = (scope) => {
  if (scope === WORKFLOW_PRODUCT_SCOPE.INTERNAL) return 'Document Validation';
  if (scope === WORKFLOW_PRODUCT_SCOPE.EXTERNAL) return 'ETVL Engine';
  return 'Workflows';
};

export const workflowProductFunctionCode = (scope) => {
  if (scope === WORKFLOW_PRODUCT_SCOPE.INTERNAL) return 'Document Validation';
  if (scope === WORKFLOW_PRODUCT_SCOPE.EXTERNAL) return 'ETVL Engine';
  return null;
};

/**
 * FundIQ Document Validation / ETVL Engine action check.
 * If productScope is omitted (undefined), this is not a FundIQ page (e.g. Treasury) — allow.
 * If productScope is null (legacy combined Workflows), either product action is enough.
 */
export const hasWorkflowProductPermission = (hasPermission, isHarmonateUser, productScope, action) => {
  if (isHarmonateUser) return true;
  if (productScope === undefined) return true;
  const code = workflowProductFunctionCode(productScope);
  if (code) return Boolean(hasPermission(code, action));
  return Boolean(
    hasPermission('Document Validation', action) ||
    hasPermission('ETVL Engine', action)
  );
};

